import React from 'react'

import { AcornsIcon, Icon } from '@acorns/icons'

import {
  BulletRow,
  BulletRowContent,
  BulletRowContentSubTitle,
  BulletRowContentTitle,
  IconContainer,
} from './styled-components'

type Props = {
  title: string
  subTitle: string
  icon: Icon
}

const BulletRowComp = (props: Props) => (
  <BulletRow>
    <IconContainer>
      <AcornsIcon icon={props.icon} width="24px" height="24px" />
    </IconContainer>
    <BulletRowContent>
      <BulletRowContentTitle>{props.title}</BulletRowContentTitle>
      <BulletRowContentSubTitle>{props.subTitle}</BulletRowContentSubTitle>
    </BulletRowContent>
  </BulletRow>
)

export default BulletRowComp
